import { useSession } from "@outschool/ui-auth";
import React from "react";

import { SelectedLearner, useChatContext } from "../chatProvider";
import { ChatInputSelection } from "./ChatInputSelection";

type LearnerSelectionProps = {
  label: string;
};
export const LearnerSelection = ({ label }: LearnerSelectionProps) => {
  const { updateSelectedLearner } = useChatContext();
  const { currentUser } = useSession();
  const learners = currentUser?.children;

  return (
    <>
      {!!learners?.length ? (
        <ChatInputSelection
          label={label}
          options={learners}
          optionLabel={`name`}
          onSelect={(learner: SelectedLearner) =>
            updateSelectedLearner(learner)
          }
          clearable
        />
      ) : null}
    </>
  );
};
